import {isFunction} from 'lodash'

export const RIF = (test, component) => (test ? (isFunction(component) ? component(test) : component) : undefined)
